import { useMutation, useQueryClient } from '@tanstack/react-query'

import { updateConversationSharing } from 'modules/coaching/api'
import { coachingKeys } from 'modules/coaching/query-keys'

import type { components } from '@startech/openapi'

type GetConversationResponse = components['schemas']['GetConversationResponse']

export const useInvalidateConversationMessages = () => {
  const queryClient = useQueryClient()
  return (conversationId: string) => {
    void queryClient.invalidateQueries({
      queryKey: coachingKeys.conversationMessages(conversationId),
    })
  }
}

export const useUpdateConversationSharingMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ conversationId, isPublic }: { conversationId: string; isPublic: boolean }) =>
      updateConversationSharing(conversationId, isPublic),
    onSuccess: (response, variables) => {
      queryClient.setQueriesData<GetConversationResponse>(
        { queryKey: coachingKeys.conversationDetail(variables.conversationId) },
        current => {
          if (!current) {
            return current
          }
          return {
            ...current,
            access: {
              ...current.access,
              isPublic: response.data.isPublic,
            },
          }
        }
      )
    },
  })
}
